import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref } from 'vue';
import OrderQuotableCode from '../../common/code/OrderQuotableCode';

interface Props {
  // 選択フラグ 0:未選択、1:選択済み
  isSelected: string;
  // 注文問合フラグ（注文されてるか、問い合わせされてるか） 0：注文、1:問い合わせ
  orderQuotableFlg: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'OrderButton',
  props: {
    isSelected: {},
    orderQuotableFlg: {}
  },
  emits: ['order'],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;

const order = () => {
  emit('order');
};

const isDisable = (): boolean => {
  // 問い合わせまたはエラーの場合、true
  if (props.orderQuotableFlg === OrderQuotableCode.QUOTABLE) {
    return true;
  }
  return false;
};

const setDisableClass = (): string => {
  // 問い合わせまたはエラーの場合、非活性
  if (props.orderQuotableFlg === OrderQuotableCode.QUOTABLE) {
    return 'disabled';
  }

  // 選択済みの場合、活性
  if (props.isSelected === '1') {
    return 'inactive';
  }

  return '';
};

const popupFlg = ref<boolean>(false);

const sleep = (second: number) =>
  new Promise((resolve) => {
    setTimeout(resolve, second * 1000);
  });

const hide = async () => {
  await sleep(0.5);
  popupFlg.value = false;
};

return (_ctx: any,_cache: any) => {
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_banner = _resolveComponent("q-banner")!
  const _component_q_popup_proxy = _resolveComponent("q-popup-proxy")!
  const _component_q_btn = _resolveComponent("q-btn")!

  return (_openBlock(), _createBlock(_component_q_btn, {
    icon: _ctx.isSelected === '1' ? 'mdi-close' : 'mdi-cart-outline',
    class: _normalizeClass('orderable ' + setDisableClass()),
    disabled: isDisable(),
    label: _ctx.isSelected === '1' ? '取消' : '注文',
    onClick: order
  }, {
    default: _withCtx(() => [
      _createVNode(_component_q_popup_proxy, {
        modelValue: popupFlg.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((popupFlg).value = $event)),
        "transition-show": "fade",
        "transition-hide": "fade",
        onShow: hide
      }, {
        default: _withCtx(() => [
          _createVNode(_component_q_banner, null, {
            avatar: _withCtx(() => [
              _createVNode(_component_q_icon, {
                name: _ctx.isSelected === '1' ? 'add_shopping_cart' : 'remove_shopping_cart',
                color: "primary"
              }, null, 8, ["name"])
            ]),
            default: _withCtx(() => [
              _createTextVNode(" " + _toDisplayString(_ctx.isSelected === '1' ? '追加されました' : '削除されました'), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _: 1
  }, 8, ["icon", "class", "disabled", "label"]))
}
}

})